import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../store';
import { getErrorMessage } from '../../utils/errorHandler';
import questionsAPI, { Questions } from './preguntasAPI';

export interface Preguntas {
  id: number;
  pregunta: string;
  respuesta: string;
  activa: string;
  created_at: Date | string;
  updated_at: null;
}

interface QuestionsState {
  status: 'loading' | 'idle' | 'error' | 'success';
  error?: string;
  list: Questions[];
}

export const initialState: QuestionsState = {
  status: 'idle',
  list: [],
};

export const getQuestions = createAsyncThunk<
  Questions[],
  string,
  { rejectValue: string }
>('preguntas/', async (searchWord, thunkAPI) => {
  try {
    const response = await questionsAPI.getQuestions(searchWord);

    if (response.status === 'error') {
      return thunkAPI.rejectWithValue(response.error);
    }

    return response.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(getErrorMessage(err));
  }
});

export const PreguntasState = createSlice({
  name: 'PreguntasState',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getQuestions.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getQuestions.fulfilled, (state, action) => {
        state.status = 'success';
        state.list = action.payload;
      })
      .addCase(getQuestions.rejected, (state, action) => {
        state.status = 'error';
        state.error = action.payload;
      });
  },
});

export const getPreguntasList = (state: RootState) => state.preguntas.list;

export const getPreguntasStatus = (state: RootState) => state.preguntas.status;

export default PreguntasState.reducer;
